import { baseAppApi } from '@/core/network/baseAppApi';
import { COMMON_HEADERS } from '@/core/network/network.constants';
import { getFirstErrorOrDefault } from '@/core/network/network.utils';
import tokens from '@/notifications/tokens.json';

export interface NotificationRequest {
  message: string;
  isActive: boolean;
}

export interface NotificationResponse {
  data: {
    notificationId: number;
    message: string;
    isActive: boolean;
  };
}

export const notificationApi = baseAppApi.injectEndpoints({
  endpoints: (build) => ({
    getNotificationMessage: build.mutation<NotificationResponse, void>({
      query() {
        return {
          url: `v1/notification/active-notifications`,
          method: 'GET',
          headers: COMMON_HEADERS,
        };
      },
      transformErrorResponse(response) {
        if (response.status === 404) {
          return '404';
        } else {
          return getFirstErrorOrDefault(response, tokens['FETCHING_ERROR']);
        }
      },
    }),
    updateNotificationMessage: build.mutation<NotificationResponse, NotificationRequest>({
      query: ({ message, isActive }) => ({
        url: `v1/notification/updated`,
        method: 'POST',
        headers: COMMON_HEADERS,
        body: { message, isActive },
      }),
      transformErrorResponse(response) {
        return getFirstErrorOrDefault(response, tokens['UPDATE_ERROR']);
      },
      invalidatesTags: ['NOTIFICATIONS'],
    }),
  }),
  overrideExisting: false,
});
